import { generateVacanciesOnboardingReport } from "../../services/reports_services";
export const reports_types = [
  {
    id: 1,
    nome: "Relatório de volumetria de matriculas",
    descricao: `Lista informações dos processos de matricula da
                    etapa atual.
                    Exibe:
                        - A quantidade de alunos matriculados;
                        - A quantidade de vagas disponíveis;
                        - A quantidade de excedentes.
                    As informações estão agrupadas por Curso e Forma de Ingresso.
                    `,
    action: generateVacanciesOnboardingReport,
  },
];
